import { convertCase } from '../../_utils/utils'
import clone from 'clone'
import { stripUndefined } from '../../_utils/strip-undefined'

export class NotificationNativeAndroidContentModel {
    public static build(props: NotificationNativeAndroidContentModel | any): NotificationNativeAndroidContentModel {
        const data = props instanceof NotificationNativeAndroidContentModel ? props.serialize() : clone(props)
        const scData = convertCase(data, 'snake')

        const model = new NotificationNativeAndroidContentModel()
        model.setChannelId(scData.channel_id)
        model.setPriority(scData.priority)
        model.setTitle(scData.title)
        model.setBody(scData.body)
        model.setIconUrl(scData.icon_url)
        model.setImageUrl(scData.image_url)
        model.setLandingUrl(scData.landing_url)

        return model
    }

    private channelId: number | undefined
    private priority: string | undefined
    private title: string | undefined
    private body: string | undefined | null
    private imageUrl: string | undefined | null
    private iconUrl: string | undefined | null
    private landingUrl: string | undefined | null

    public clone(): NotificationNativeAndroidContentModel {
        return NotificationNativeAndroidContentModel.build(this)
    }

    public serialize(): any {
        return stripUndefined({
            priority: this.getPriority(),
            channel_id: this.getChannelId(),
            title: this.getTitle(),
            body: this.getBody(),
            icon_url: this.getIconUrl(),
            image_url: this.getImageUrl(),
            landing_url: this.getLandingUrl(),
        })
    }

    public getChannelId(): number | undefined {
        return this.channelId
    }
    public setChannelId(channel: number | undefined) {
        this.channelId = channel
    }

    public getPriority(): string | undefined {
        return this.priority
    }
    public setPriority(priority: string | undefined) {
        this.priority = priority
    }

    public getTitle(): string | undefined {
        return this.title
    }
    public setTitle(title: string | undefined) {
        this.title = title
    }

    public getBody(): string | undefined | null {
        return this.body
    }
    public setBody(body: string | undefined): void {
        this.body = body
    }

    public getIconUrl(): string | undefined | null {
        return this.iconUrl
    }
    public setIconUrl(iconUrl: string | undefined | null): void {
        this.iconUrl = iconUrl
    }

    public getImageUrl(): string | undefined | null {
        return this.imageUrl
    }
    public setImageUrl(imageUrl: string | undefined | null): void {
        this.imageUrl = imageUrl
    }

    public getLandingUrl(): string | undefined | null {
        return this.landingUrl
    }
    public setLandingUrl(landingUrl: string | undefined | null): void {
        this.landingUrl = landingUrl
    }
}
